/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RoadFeatureTypesWithBruksklasse {
    BOMSTASJON = 'Bomstasjon',
    RASTEPLASS = 'Rasteplass',
    VEGKAMERA = 'Vegkamera',
    HEIGHT = 'Height',
    DOGNHVILEPLASS = 'Dognhvileplass',
    LADESTASJON = 'Ladestasjon',
    LENGTH = 'Length',
    TURISTVEG = 'Turistveg',
    WEIGHT = 'Weight',
    FERGE = 'Ferge',
    DATEX3TRAFFIC_MESSAGE = 'Datex3TrafficMessage',
    TRAFFIC_MESSAGE = 'TrafficMessage',
    SWEDISH_TRAFFIC_MESSAGE = 'SwedishTrafficMessage',
    FINNISH_TRAFFIC_MESSAGE = 'FinnishTrafficMessage',
    VEGSPERRING = 'Vegsperring',
    VARUTSATT_VEG = 'VarutsattVeg',
    JERNBANEKRYSSING_MED_SAERSKILT_FARE = 'JernbanekryssingMedSaerskiltFare',
    MEASUREMENT_SITE = 'MeasurementSite',
    MISSING_BRUKSKLASSE = 'MissingBruksklasse',
    SPESIELL_BEGRENSNING_BRUKSKLASSE = 'SpesiellBegrensningBruksklasse',
    SPESIELL_BEGRENSNING_MAKS_VOGNTOG_LENGDE = 'SpesiellBegrensningMaksVogntogLengde',
    SPESIAL_TRANSPORT_VEGGRUPPE = 'SpesialTransportVeggruppe',
    TUNNEL = 'Tunnel',
    TRAFIKKREGULERING = 'Trafikkregulering',
    GJENNOMKJORING_FORBUDT = 'GjennomkjoringForbudt',
}
